import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/PortfolioWebsite/PortfolioWebsite/app/tools/image-compressor/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/PortfolioWebsite/PortfolioWebsite/components/blog/BlogFooter.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/PortfolioWebsite/PortfolioWebsite/node_modules/next/dist/client/script.js");
